module.exports = __webpack_public_path__ + "img/cap_09.b5c68aea.jpg";